import { InnerView, SiteDeclaration } from "~/components";
import { FBProfile } from "~/.server/api";

interface ContactInnerViewProps {
  profile?: FBProfile;
}

export default function ContactInnerView({ profile }: ContactInnerViewProps) {
  return (
    <InnerView id="contact" title="Contact" showFooter={false} user={profile}>
      <div className="p-4 flex flex-col gap-2 text-text">
        <p>
          We are happy when our customers are happy! If you have any questions
          about our service, payment, or if you are experiencing any
          difficulties, please use the email address below.
        </p>
        <p>hello@flirtybum.com</p>
        <h1 className="text-xl font-bold text-primary">Address</h1>
        <ul>
          <li>PWR Network Limited</li>
          <li>Nicolaou Pantadromos Center, 5th floor,</li>
          <li>Flat/Office 503B, Block B,</li>
          <li>3026 Limassol</li>
          <li>Cyprus</li>
        </ul>
        <ul>
          <li>Registration: HE404915</li>
          <li>VAT: CY10404915G</li>
        </ul>
        <SiteDeclaration />
      </div>
    </InnerView>
  );
}
